import { z } from 'zod';
import { GetProcessConnectionsResponseSchema } from './get-process-connections.schema';
export const getProcessConnectionsContract = {
    method: 'GET',
    path: '/api/v2/process/:id/connections',
    description: 'Get all incoming and outgoing connections for a process with populated process names',
    requestSchema: z.object({}),
    responseSchema: GetProcessConnectionsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized',
            404: 'Process not found'
        }
    }
};

//# sourceMappingURL=get-process-connections.contract.js.map